import logoTechtime from "./logotype-techtime-horizontal-fond-clair.png";
import Logo404 from "./Techtime-404.png";

export const Images = {
  LogoTechtime: logoTechtime,
  Logo404: Logo404,
};
